import type { DelayActionUI, TimerUI } from './DeviceActionUI';

export interface GroupAction {
	name: string;
	value: string | number;
}

export interface GroupActionUI {
	_type: 'group';
	group_id: number;
	actions: GroupAction[];
	delay: DelayActionUI | undefined;
	timer: TimerUI;
}

export function is_group_action_ui(obj: any): obj is GroupAction {
	return (
		typeof obj === 'object' &&
		typeof obj.group_id === 'number' &&
		typeof obj.actions !== 'undefined' &&
		typeof obj._type !== 'undefined' &&
		obj._type === 'group'
	);
}
